import { Typography } from '@mui/material';
import type { FC } from 'react';
import { tooltipCell } from './styles';

interface ReferenceStringDisplayProps {
    data: string;
    fullCell?: boolean;
}

const ReferenceStringDisplay: FC<ReferenceStringDisplayProps> = ({ data, fullCell }) => (
    <Typography sx={{ ...tooltipCell, ...(fullCell && { height: 1, width: 1 }) }}>{data}</Typography>
);

export default ReferenceStringDisplay;
